import moment, {Moment} from 'moment';
import {Box, Grid, Typography} from '@mui/material';
import {FlatDateInput} from '../flat-date-input/flat-date-input';
import {FlatStartsAtTime} from '../flat-starts-at-time/flat-starts-at-time';

/** Longest reason that can be given (the same as in the backend) */
export const REASON_MAX_LENGTH = 300;

/** Date of `date` with the time of `time` */
export const withTimeOf = (date: Moment, time: Moment): Moment =>
  date.clone().set({hour: time.hour(), minute: time.minute(), second: 0, millisecond: 0});

/** Now, to the minute */
export const nowToTheMinute = (): Moment => moment().set({second: 0, millisecond: 0});

type DateTimeFieldsProps = {
  dateLabel: string;
  timeLabel: string;
  value: Moment;
  errors?: string;
  onChange: (value: Moment) => void;
};

/** A date and a time, in two fields side by side. To be used inside a `Grid` container. */
export const DateTimeFields = ({
  dateLabel,
  timeLabel,
  value,
  errors,
  onChange,
}: DateTimeFieldsProps) => (
  <>
    <Grid item xs={12} sm={6}>
      <FlatDateInput
        label={dateLabel}
        disableFuture
        value={value.toDate()}
        onChange={(date: Date | null | undefined) =>
          date && onChange(withTimeOf(moment(date), value))
        }
        errors={errors}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FlatStartsAtTime
        label={timeLabel}
        value={value.toDate()}
        onAccept={(time) => time && onChange(withTimeOf(value, moment(time)))}
      />
    </Grid>
  </>
);

/** A label with a value below it, to read what is going to be registered */
export const SummaryRow = ({label, value}: {label: string; value?: string}) => (
  <Box sx={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
    <Typography sx={{fontSize: '14px', fontWeight: 500, color: 'var(--dcm-gray-general)'}}>
      {label}
    </Typography>
    <Typography sx={{fontSize: '14px', fontWeight: 500, overflowWrap: 'anywhere'}}>
      {value}
    </Typography>
  </Box>
);
